/// <amd-module name="SuiteCommerce.StockNotifications.PDP.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.PDP.View", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.StockNotifications.Configuration", "SuiteCommerce.StockNotifications.Utils", "SuiteCommerce.StockNotifications.Subscription.Create.View", "suitecommerce_stocknotifications_pdp.tpl", "SuiteCommerce.StockNotifications.Instrumentation", "SuiteCommerce.StockNotifications.Item.Model"], function (require, exports, _, Backbone_1, Configuration_1, Utils_1, Subscription_Create_View_1, pdpTpl, Instrumentation_1, Item_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PdpView = /** @class */ (function (_super) {
        __extends(PdpView, _super);
        function PdpView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = pdpTpl;
            _this.events = {
                'click [data-action="stocknotifications-dropdown-show"]': 'logOnExpand',
            };
            _this.application = options.container;
            _this.pdp = options.pdp;
            _this.pdpItemInfo = _this.pdp.getItemInfo();
            _this.model.setFilteredOutOfStockItemsIds(_this.pdpItemInfo.item.matrixchilditems_detail);
            var itemOptions = _this.pdpItemInfo.options;
            _this.model.isMatrixItem = false;
            var matrixDimensionOptions = _.filter(itemOptions, function (option) {
                return option.isMatrixDimension;
            });
            _this.model.isMatrixItem = !!matrixDimensionOptions.length;
            _this.pdp.on('afterOptionSelection', function () { return _this.render(); });
            _this.logRenderOnPdp();
            return _this;
        }
        PdpView.prototype.render = function () {
            this.isVisible = this.$('[data-type="stocknotifications-dropdown"]').is(':visible');
            Backbone_1.View.prototype.render.apply(this);
            return this;
        };
        PdpView.prototype.destroy = function () {
            Backbone_1.View.prototype.destroy.apply(this);
        };
        Object.defineProperty(PdpView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'StockNotifications.Subscription.Create': function () {
                        return new Subscription_Create_View_1.SubscriptionCreateView({
                            application: _this.application,
                            pdp: _this.pdp,
                            selectedProduct: _this.getSelectedProduct(),
                            matrixParentId: _this.getMainPdpItem(),
                            selectedMatrixChild: _this.getSelectedMatrixChild(),
                            pdpModel: _this.model
                        });
                    }
                };
            },
            enumerable: true,
            configurable: true
        });
        PdpView.prototype.itemShouldShowStockSubscription = function () {
            if (!this.pdp.getStockInfo().isInStock) {
                return this.pdpItemInfo.item.outofstockbehavior === 'Allow back orders but display out-of-stock message'
                    || this.pdpItemInfo.item.outofstockbehavior === 'Disallow back orders but display out-of-stock message';
            }
            return false;
        };
        PdpView.prototype.getSelectedProduct = function () {
            var selectedMatrixChild = this.getSelectedMatrixChild();
            if (selectedMatrixChild) {
                return selectedMatrixChild;
            }
            return this.getMainPdpItem();
        };
        PdpView.prototype.getSelectedMatrixChild = function () {
            var pdpSelectedMatrixChild = this.pdp.getSelectedMatrixChilds();
            if (pdpSelectedMatrixChild.length === 1) {
                return pdpSelectedMatrixChild[0].internalid.toString();
            }
            return null;
        };
        PdpView.prototype.getMainPdpItem = function () {
            return this.pdpItemInfo.item.internalid.toString();
        };
        PdpView.prototype.getItemUrl = function () {
            return this.pdpItemInfo.item.keyMapping_url;
        };
        PdpView.prototype.logRenderOnPdp = function () {
            var log = Instrumentation_1.default.getLog('usage');
            var itemUrl = this.getItemUrl();
            log.setParameters({
                activity: 'Render on PDP',
                clientContextURL: itemUrl
            });
            log.submit();
        };
        PdpView.prototype.logOnExpand = function () {
            this.model.toggleAccordion();
            var log = Instrumentation_1.default.getLog('usage');
            var itemUrl = this.getItemUrl();
            log.setParameters({
                activity: 'Click to expand',
                clientContextURL: itemUrl
            });
            log.submit();
        };
        PdpView.prototype.getSelectedProductName = function () {
            var itemInfo = this.pdp.getItemInfo();
            var item = new Item_Model_1.ItemModel(itemInfo.item);
            var matrixOptions = _.filter(itemInfo.options, function (option) {
                return option.isMatrixDimension;
            });
            var selectedOptions = this.pdp.getSelectedMatrixChilds();
            var selectedProductName = item.name;
            if (selectedOptions.length === 1) {
                matrixOptions.forEach(function (option) {
                    if (option.isMatrixDimension) {
                        selectedProductName += " " + selectedOptions[0][option.itemOptionId];
                    }
                });
            }
            return selectedProductName;
        };
        PdpView.prototype.getSubscribingToMessage = function () {
            var messageTemplate = Configuration_1.Configuration.get('stockNotifications.pdp.sectionText');
            return messageTemplate.replace('[[item]]', '<b>' + this.getSelectedProductName() + '</b>');
        };
        PdpView.prototype.getContext = function () {
            return {
                showView: this.itemShouldShowStockSubscription(),
                showOutOfStockMessage: this.pdp.getStockInfo().showOutOfStockMessage,
                isVisible: this.isVisible ? 'style="display: block"' : '',
                buttonTxt: Utils_1.Utils.translate(Configuration_1.Configuration.get('stockNotifications.pdp.buttonText')),
                productListLink: Configuration_1.Configuration.get('stockNotifications.pdp.productListLink'),
                subscribingToMessage: this.getSubscribingToMessage(),
                isAccordionOpen: this.model.isAccordionOpen,
                isAccordionClosed: !this.model.isAccordionOpen,
            };
        };
        return PdpView;
    }(Backbone_1.View));
    exports.PdpView = PdpView;
});
